module.exports = __webpack_public_path__ + "img/choose-up-vacanta.83ea4bb9.png";